import { Box } from "@mui/material";
import { MuiHelper } from "@/helpers";
import { colors } from "@/theme";
import ReportGenerator from "./ReportGenerator";

const Reporting: React.FC = () => {
  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{
        display: "flex", alignItems: 'center', justifyContent: 'space-between', px: 4, py: 4
      }}>
        {MuiHelper.getHeader("Reporting")}
      </Box>
      <Box sx={{
        backgroundColor: colors.neutralGrey300,
        display: 'flex',
        flex: 1,
        padding: '24px'
      }}>
        <Box sx={{
          display: 'flex', flex: 1, backgroundColor: '#fff', borderRadius: 3, padding: 2
        }}>
          <ReportGenerator />
        </Box>
      </Box>
    </Box>
  );
};

export default Reporting;
